<template>
  <div class="email-modal">
    <div class="email-modal__inner">
      <div class="email-modal__title">{{ 'auth_remember_password_successfully_title' | translate }}</div>
      <div class="email-modal__subtitle">
        {{ 'auth_remember_password_successfully_text' | translate }}
        <span>{{ email }}</span>
      </div>
      <div class="email-modal__button">
        <button class="primary" @click="$emit('close')">
          <span class="text">{{ 'auth_remember_password_successfully_button' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['email']
}
</script>

<style lang="scss" scoped>
  .email-modal {
    &__inner {
      padding: 32px;
      text-align: center;
    }
    &__title {
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 16px;
    }
    &__subtitle {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 48px;
      span {
        display: block;
        color: var(--label-secondary);
      }
    }
    &__button {
      button {
        width: 200px;
        margin: 0 auto;
      }
    }
  }
</style>
